<template>
  <va-card title="Меню">
    <va-button
      :to="{ name: 'ms-widgets-value-edit' }"
    >
      Створити
    </va-button>
    <va-data-table
      :fields="fields"
      :data="values"
      no-pagination
    >
      <template slot="marker" slot-scope="props">
        <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
      </template>

      <template slot="toggle" slot-scope="props">
        <va-toggle
          small
          v-on:input="togglePublished(props.rowData.id)"
          v-model="props.rowData.published"
        />
      </template>

      <template slot="translations" slot-scope="props">
        <va-badge color="info" :outline="!translation.status" v-for="(translation, index) in props.rowData.trans" :key="index">{{ translation.locale }}</va-badge>
      </template>

      <template slot="actions" slot-scope="props">
        <va-button
          small
          color="info"
          :to="{ name: 'ms-widgets-value-edit', params: { id: props.rowData.id } }"
        >
          Редагувати
        </va-button>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  data () {
    return {
      values: [],
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    fields () {
      return [{
        name: 'key',
        title: 'Key',
        width: '10%',
      },
      {
        name: 'content',
        title: 'Content',
        width: '40%',
      },
      {
        title: 'Опубліковано',
        name: '__slot:toggle',
        width: '20%',
      },
      {
        title: 'Переклади',
        name: '__slot:translations',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    togglePublished (id) {
      axios.put(`${process.env.VUE_APP_MS_DEV_API_URL}/${this.locale}/admin/values/${id}`, {
        published: !!this.values.find((item) => item.id === id).published,
      })
        .then(response => {
          this.showToast('Success')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    fetch () {
      axios.get(`${process.env.VUE_APP_MS_DEV_API_URL}/${this.locale}/admin/values`)
        .then(response => {
          this.values = response.data
          this.values.forEach((item) => {
            item.published = !!item.published
            // console.log(item.trans)
          })
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
        .finally(() => {
          this.loaded = true
        })
    },
  },
}
</script>

<style lang="scss">
</style>
